import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { Button, Image, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { isVideo } from '../../../utils/media';

const MoodboardMedia = ({ url }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const mediaIsVideo = useMemo(() => isVideo(url));

  return (<React.Fragment>
    <div className="square">
      {
        mediaIsVideo
          ? <div onClick={() => setShowModal(true)}>
            <video src={url}
              className={"moodboard-img "}
            >
            </video>
            <div className="moodboard-icon-play">
              <i className="fal fa-play "></i>
            </div>
          </div>
          : <img
            loading="lazy"
            className={"moodboard-img"}
            src={url}
            onClick={() => setShowModal(true)}
          />
      }
    </div>

    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      size="xl"
      className='moodboard-modal'>
      <Modal.Body className="d-flex align-items-center justify-content-center">
        {
          mediaIsVideo
            ? <video src={url}
              controls
              autoPlay
              className="w-100 h-100"
            >
              <source src={url} type="video/mp4" />
            </video>
            :
            <Image
              className="img-fit"
              src={url}
            />
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="tertiary" onClick={() => setShowModal(false)}>
          {t('influencers.common.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  </React.Fragment>);
};

MoodboardMedia.propTypes = {
  url: PropTypes.string.isRequired,
};

export default React.memo(MoodboardMedia);